// src/components/store/sections/weekly-banner/Variant2GlassyGradient.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight, Flame } from "lucide-react";
import { WeeklyBannerProps } from "./types";

export default function Variant2GlassyGradient({ banner, subdomain }: WeeklyBannerProps) {
  const imageUrl = banner?.image
    ? banner.image.startsWith("http") || banner.image.startsWith("data:")
      ? banner.image
      : `http://${subdomain ? `${subdomain}.` : ""}localhost:8000${banner.image.startsWith("/") ? "" : "/"}${banner.image}`
    : "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=800&auto=format&fit=crop&q=80";

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 select-none font-sans">
      <div className="rounded-[40px] bg-gradient-to-r from-indigo-950 via-purple-900 to-slate-950 border border-purple-500/30 p-8 sm:p-14 flex flex-col md:flex-row items-center justify-between gap-8 overflow-hidden relative shadow-2xl group transition-all">
        <div className="absolute top-0 right-1/4 w-96 h-96 bg-fuchsia-500/20 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-10 w-80 h-80 bg-blue-500/20 rounded-full blur-3xl pointer-events-none" />

        <div className="space-y-4 max-w-xl z-10 text-left">
          <span className="text-[11px] font-black text-fuchsia-300 uppercase tracking-widest inline-flex items-center gap-1.5 bg-fuchsia-950/60 border border-fuchsia-500/40 px-3.5 py-1.5 rounded-full backdrop-blur-md shadow-sm">
            <Flame className="w-3.5 h-3.5 text-rose-400 fill-rose-400" />
            {banner?.badge_title || "LIMITED TIME OFFER"}
          </span>

          <h2 className="text-3xl sm:text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white via-slate-100 to-purple-200 leading-tight tracking-tight">
            {banner?.title || "Elevate Your Everyday Style"}
          </h2>

          <p className="text-xs sm:text-sm text-purple-200/80 leading-relaxed max-w-md font-medium">
            {banner?.subtitle ||
              "Special weekly curations crafted for elegance, comfort, and premium lifestyle."}
          </p>

          <div className="pt-2">
            <Link
              href={banner?.target_url || "/products"}
              className="px-8 py-3.5 rounded-full bg-gradient-to-r from-fuchsia-600 to-indigo-600 hover:from-fuchsia-500 hover:to-indigo-500 text-white font-black text-xs inline-flex items-center gap-2 transition-all shadow-xl shadow-fuchsia-600/30 active:scale-95 cursor-pointer"
            >
              <span>{banner?.button_text || "Claim Offer"}</span>
              <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="w-72 sm:w-[420px] aspect-[4/3] relative flex-shrink-0 flex items-center justify-center">
          <div className="absolute w-60 h-14 rounded-full bg-purple-600/30 blur-2xl bottom-2" />
          <Image
            src={imageUrl}
            alt={banner?.title || "Weekly Banner"}
            fill
            unoptimized
            className="object-contain drop-shadow-[0_25px_30px_rgba(0,0,0,0.8)] group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>
    </section>
  );
}

export { Variant2GlassyGradient };